import React from 'react';
import { Link, withRouter } from 'react-router-dom';
import axios from '../res/axios';
import { bindActionCreators } from 'redux';
import * as actionCreators from '../res/actions';
import { connect } from 'react-redux';
import jwtDecode from 'jwt-decode';

import { SideNavigation, Spinner, Toggle } from '@amzn/awsui-components-react/polaris';
import Image from './Image';
import * as awsui from '@amzn/awsui-design-tokens/polaris.js';


const mapStateToProps = (state) => {
  return {
    user: state.appState.user,
    domains: state.domains,
    loading: state.appState.isLoading,
    serverClientTimeOffset: state.appState.serverClientTimeOffset
  }
}

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({
    addNotification: actionCreators.addNotification,
    clearAllNotifications: actionCreators.clearAllNotifications,
    setDomainsList: actionCreators.setDomainsList,
    clearDomainsList: actionCreators.clearDomainsList,
    setLoadingToTrue: actionCreators.setLoadingToTrue,
    setLoadingToFalse: actionCreators.setLoadingToFalse,
    setLoggedInUser: actionCreators.setLoggedInUser,
    setServerClientTimeOffset: actionCreators.setServerClientTimeOffset,
  }, dispatch);
}

const getAlias = () => {
  try {
    const token = localStorage.getItem('BOTSE_SESSION_TOKEN');
    return jwtDecode(token).sub;
  }
  catch (err) {
    console.log("Critical: Token not found.", err);
  }
}

function getRandomInt(max = 100) {
  return Math.floor(Math.random() * Math.floor(max));
}

class Navigation extends React.Component {

  constructor(props) {
    super(props);
    
    this.state = {
      selectedDomain: '/' + window.location.pathname.split('/')[1],
      isDarkUIChecked: false
    };
    this.getItems = this.getItems.bind(this);
    this.handleNavLinkClick = this.handleNavLinkClick.bind(this);
    this.handleTimeOffset = this.handleTimeOffset.bind(this);
    this.darkUIOnChange = this.darkUIOnChange.bind(this);
    this.changeDarkUILocalActions = this.changeDarkUILocalActions.bind(this);
  }



  componentDidMount() {
    this.changeDarkUILocalActions();
    console.log("Hello World ComponentDidMount");
    this.props.setLoadingToTrue();
    let headers = {
      'x-csrf-token': localStorage.getItem('BOTSE_SESSION_TOKEN'),
      'Action': 'Domain:ListDomains'
    };
    this.props.setLoggedInUser(getAlias());
    axios.get("action", { headers: headers })
      .then(res => {
        res.data = JSON.parse(res.data);
        const data = res.data.data.domains;
        const servertime = res.data.data.timestamp;
        this.handleTimeOffset(servertime);
        this.props.setDomainsList(data);
        this.props.setLoadingToFalse();
      })
      .catch(() => {
        this.props.clearDomainsList();
        this.props.setLoadingToFalse();
        var notification = {
          id: getRandomInt(),
          type: "error",
          dismissible: true,
          header: "Failed to fetch the profile list!",
          content: "Please check your internet connectivity and reload the page.",
        };
        this.props.addNotification(notification);
       
      });
  }

  handleTimeOffset(servertime) {
    const clienttime = Date.now() / 1000 | 0;
    if (Math.abs(clienttime - servertime) > 2) {
      var notification = {
        id: getRandomInt(),
        type: "warning",
        dismissible: false,
        header: "Your system clock is not in synchronization with the current time.",
        content: "Bottlenose will try to compensate for this. However, we strongly recommend you adjust your system clock and refresh the page before proceeding.",
      };
      this.props.addNotification(notification);
    }
    this.props.setServerClientTimeOffset((clienttime - servertime) * 1000);
  }

  changeDarkUILocalActions = () => {
    
    const globalDarkModeSetting = window.localStorage.getItem('dark-mode-preference') === 'true';
    const currentLocalDarkModeSetting = this.state.isDarkUIChecked;
    if (globalDarkModeSetting !== currentLocalDarkModeSetting) {
      window.document.body.classList.toggle('awsui-polaris-dark-mode', globalDarkModeSetting);
      this.setState({isDarkUIChecked: globalDarkModeSetting});
    }
   
   }


  darkUIOnChange = (detail) => {
    
    window.localStorage.setItem('dark-mode-preference', detail.checked);
    window.document.body.classList.toggle('awsui-polaris-dark-mode');
    this.setState({isDarkUIChecked: detail.checked});

  }

  render() {
    

   
    
    return (
      <div className='custom-app-layoutx__navigation' >
        <div className='custom-app-layout-drawer__header'>
          <h2 className='custom-app-layout-drawer__header-title'>
            <Link to='/'>Bottlenose v1.0</Link>
          </h2>
          {/* <p> Version 0.1 </p> */}
          <Toggle onChange={({detail})=> this.darkUIOnChange(detail)} checked={this.state.isDarkUIChecked}>
            Dark Mode
          </Toggle>
                                </div> 
        <div>
          <h2 className="awsui-side-navigation__header">
            <Image
              src={"https://internal-cdn.amazon.com/badgephotos.amazon.com/?uid=" + this.props.user}
              width={25} height={25}
              mode='fill'
              style={{ display: 'inline-block', verticalAlign: 'middle' }}
            />
            <Link
              to={"https://phonetool.amazon.com/users/" + this.props.user}
              className="awsui-side-navigation__header-link"
              target="_blank"
              style={{ marginLeft: '5px' }}
            >@{this.props.user}</Link>
          </h2>
          <hr className="awsui-side-navigation__divider awsui-side-navigation__divider--header" />
        </div>

        <div>
          <SideNavigation activeHref={this.state.selectedDomain} items={this.getItems()} onFollow={this.handleNavLinkClick}></SideNavigation>

        </div>
        {/* <div className="awsui-util-container">
          <div>
            <h3>Howdy, {this.props.user}!</h3>
            <p> Choose a domain to see challenges! </p>
          </div>
        </div> */}
        {/* <div className='custom-app-layout-drawer__content'>
          <ExpandableSection
            variant='borderless'
            className='custom-expandable-section'
            header='Domains'
            expanded={true}
          >
            <ul className='custom-expandable-section__content awsui-list-unstyled'>
              {this.props.domains.map(domain => (
                <li key={domain.id}><Link to={domain.id}>{domain.name}</Link></li>
              ))}
            </ul>
          </ExpandableSection>
          <hr/>
        </div> */}
      </div>
    );
  }

  handleNavLinkClick(event) {
    // if (event.detail.href !== "https://w.amazon.com/bin/view/AWS_SE_Labs/Submit#HBottlenose" && event.detail.href !== "https://w.amazon.com/bin/view/AWS_SE_Labs/" && event.detail.href !== "https://tt.amazon.com/quicklink/Q001066758" && event.detail.href !== "https://tt.amazon.com/quicklink/Q001068656") {
    //Earlier 4 URLs were whitelist for them to open in a new tab. Using "external" parameter for this instead, as all external URL should be open in a new tab.
    if (event.detail.external !== true) {
        event.preventDefault();
      if (event.detail.text !== "Loading")
        this.setState({
          selectedDomain: event.detail.href
        });
      this.props.history.push(event.detail.href);
    }
  }

  getHeader() {
    return {
      "href": "https://phonetool.amazon.com/users/sarasuda",
      "text": "@sarasuda",
      "external": true
    }
  }

  getItems() {
    let itemArray = [{
      "type": "link",
      "text": "Loading",
      "href": "/",
      "info": <Spinner></Spinner>
    }];
    if (!this.props.loading) {
      itemArray = this.props.domains.map(item => {
        return {
          "type": "link",
          "text": item.name,
          "href": "/" + item.id
        };
      })
      //Sorting Profiles in ascending order for left navigation menu
      itemArray.sort((a, b) => (a.text.toLowerCase() > b.text.toLowerCase()) ? 1 : ((b.text.toLowerCase() > a.text.toLowerCase()) ? -1 : 0));

    }
    return [
      { type: "link", text: "Home", href: "/" },
      { type: "link", text: "My Dashboard", href: "/dashboard" },
      { type: "link", text: "Leaderboard", href: "/leaderboard" },
      { type: "divider" },
      {
        type: "section",
        text: "Profiles",
        items: itemArray
      },
      { type: "divider" },
      {
        type: "link",
        text: "Submit a Challenge",
        href: "https://w.amazon.com/bin/view/AWS_SE_Labs/Submit#HBottlenose",
        external: true
      },
      {
        type: "link",
        text: "Wiki Home",
        href: "https://w.amazon.com/bin/view/AWS_SE_Labs/",
        external: true
      },
      { type: "divider" },
      {
        type: "link",
        text: "New Feature Request",
        href: "https://issues.amazon.com/issues/create?template=9c7271df-f619-419c-bfe1-ac472558be2f",
        external: true
      },
      {
        type: "link",
        text: "Gamification & Experience Survey",
        href: "https://survey.fieldsense.whs.amazon.dev/survey/7a57240b-1377-4cd8-b685-bec49b7e07e7",
        external: true
      },
      {
        type: "link",
        text: "Contact Us",
        href: "https://issues.amazon.com/issues/create?template=7e77e131-1794-415f-a993-d292844eadcc",
        external: true
      }
    ]
  }
}
const NavigationWithRouter = withRouter(Navigation);
export default connect(mapStateToProps, mapDispatchToProps)(NavigationWithRouter);



// WEBPACK FOOTER //
// ./src/app/components/Navigation.jsx



// WEBPACK FOOTER //
// ./src/app/components/Navigation.jsx